export const CVData = [
    {
        sectionTitle: "Education",
        year: [
            {
                value: "In Progress",
                items: [
                    ["BFA, Printmaking Concentration, Colorado State University, Fort Collins, CO"],
                    ["Certificate of Korean Studies, Colorado State University, Fort Collins, CO"]
                ]
            },
            {
                value: 2024,
                items: [
                    ["Frogman's Print Workshops, Iowa City, IA"]
                ]
            },
            {
                value: 2023,
                items: [
                    ["AA, Front Range Community College, Fort Collins, CO"],
                    ["Certificate of Multimedia Fundamentals"]
                ]
            }
        ]
    },
    {
        sectionTitle: "Teaching & Work Experience",
        year: [
            {
                value: "2023 - Present",
                items: [
                    ["Teaching Assistant, The Beet Education Center printmaking workshop, Loveland, CO"],
                ]
            },
            {
                value: 2025,
                items: [
                    ["Printmaking Instructor, Frost Valley YMCA, Claryville, NY"],
                ]
            }
        ]
    },
    {
        sectionTitle: "Group Exhibitions",
        year: [
            {
                value: 2025,
                items: [
                    ["Hello Plant Friend,", " Traveling group exhibition, in collaboration with the Hello Print Friend Podcast"]
                ]
            },
            {
                value: 2023,
                items: [
                    ["Anarchy, Rules We Should Break, and Mutual Destruction,", " Iowa State University Memorial Union Gallery, Ames, IA"],
                    ["FRCC Student Art Show,", " Art Lab Fort Collins, Fort Collins, CO"]
                ]
            },
            {
                value: 2022,
                items: [
                    ["The Overwintering Project,", " Louis Joel Gallery, Altona Victoria, Australia"]
                ]
            }
        ]
    },
    {
        sectionTitle: "Juried Exhibitions",
        year: [
            {
                value: 2026,
                items: [
                    ["Annual Student Exhibition,", " Curfman Gallery, Fort Collins, CO"],
                    ["Printed Page V,", " Anderson Academic Commons, Denver, CO"]
                ]
            },
            {
                value: 2024,
                items: [
                    ["528.0,", " Arvada Center for the Arts and Humanities, Arvada, CO"],
                    ["A Fine Print,", " Lakewood Arts Center, Lakewood CO"],
                    ["MoPrint @1011,", " Littleton, CO"],
                    ["Printed Page IV,", " Spark Gallery, Denver, CO"],
                    ["Stand Out Prints,", " Highpoint Center for Printmaking, Minneapolis, MN"]
                ]
            }
        ]
    },
    {
        sectionTitle: "Publications",
        year: [
            {
                value: 2023,
                items: [
                    ["AvantArt,", " Issue 2, Front Range Community College"]
                ]
            },
            {
                value: 2022,
                items: [
                    ["AvantArt,", " Issue 1, Front Range Community College"]
                ]
            }
        ]
    },
    {
        sectionTitle: "Permanent Collections",
        year: [
            {
                value: "",
                items: [
                    ["Mesa State University, Grand Junction, CO"],
                    ["Topeka and Shawnee County Public Library, Topeka, K"],
                ]
            }
        ]
    },
];